var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2260_31774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 12 19 12.0012 19 12.0017C18.9988 12.3943 18.8448 12.7624 18.5648 13.0378L16.1487 15.416C16.0921 15.472 16.018 15.5 15.9439 15.5C15.8687 15.5 15.7934 15.4708 15.7362 15.4131C15.6237 15.2987 15.6248 15.1138 15.7397 15.0007L18.1559 12.6224C18.2516 12.5279 18.3198 12.4148 18.3636 12.2923H8.79167C8.63067 12.2923 8.5 12.1616 8.5 12.0006C8.5 11.8396 8.63067 11.7089 8.79167 11.7089H18.3642C18.3204 11.5847 18.2522 11.4703 18.1553 11.3752L15.7397 8.99992C15.6248 8.88733 15.6231 8.70242 15.7362 8.5875C15.8488 8.472 16.0337 8.47083 16.1487 8.584L18.5642 10.9593C18.8448 11.2358 19 11.6045 19 11.9988C19 11.9988 19 11.9994 19 12ZM11.7083 13.75C11.5473 13.75 11.4167 13.8807 11.4167 14.0417V16.375C11.4167 17.5008 10.5008 18.4167 9.375 18.4167H7.625C6.49917 18.4167 5.58333 17.5008 5.58333 16.375V7.625C5.58333 6.49917 6.49917 5.58333 7.625 5.58333H9.375C10.5008 5.58333 11.4167 6.49917 11.4167 7.625V9.95833C11.4167 10.1193 11.5473 10.25 11.7083 10.25C11.8693 10.25 12 10.1193 12 9.95833V7.625C12 6.17775 10.8222 5 9.375 5H7.625C6.17775 5 5 6.17775 5 7.625V16.375C5 17.8222 6.17775 19 7.625 19H9.375C10.8222 19 12 17.8222 12 16.375V14.0417C12 13.8807 11.8693 13.75 11.7083 13.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2260_31774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.14fbc5bb003281c941bb64981af05368.svg";
export { ForwardRef as ReactComponent };